import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import TaskTemplateFactory from "../../Entity/Factories/TaskTemplateFactory";

export default function* taskTemplateList(action: ActionInterface): any {
  try {

    const res = yield call(Http.get, "task-templates");

    const taskTemplates = res.data.map(taskTemplate => {
      return TaskTemplateFactory.create(taskTemplate);
    });

    yield put({
      type: Constants.GLOBAL_TASK_TEMPLATE_LIST_SUCCESS,
      payload: {
        taskTemplates: taskTemplates
      }
    });

  } catch (err) {
    // should signout user if entity could not be loaded
    yield put({
      type: Constants.PAGE_SIGNOUT_START
    });
    
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchTaskTemplateList() {
  yield takeEvery(Constants.GLOBAL_TASK_TEMPLATE_LIST, taskTemplateList);
}
